'use client';

import StepTransition from '@/components/Steps/transition/StepTransition';

const StepsTemplate = ({ children }: { children: React.ReactNode }) => (
  <StepTransition>{children}</StepTransition>
);

export default StepsTemplate;
